import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  border-top: ", ";\n  color: ", ";\n  display: flex;\n  font-weight: ", ";\n  height: ", "em;\n  justify-content: space-between;\n  padding-left: 12px;\n  z-index: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { color, typography } from '@scp/ui-shared/theme/variables';
var HEADER_HEIGHT = 2.57;
var E2E_MENU_HEADER_SUFFIX = '-menu-header';
var MenuHeader = styled.div(_templateObject(), color.backgroundSecondary, color.border, function (props) {
  return props.showTopBorder ? "1px solid ".concat(color.border) : 'none';
}, color.textPrimary, typography.fontWeightSemiBold, HEADER_HEIGHT);
export var DropdownMenuHeader = function DropdownMenuHeader(_ref) {
  var title = _ref.title,
      showTopBorder = _ref.showTopBorder,
      actionButton = _ref.actionButton,
      selectedItemsCount = _ref.selectedItemsCount;
  return React.createElement(MenuHeader, {
    showTopBorder: showTopBorder
  }, React.createElement("span", {
    "data-e2e": getE2eLabel(title, E2E_MENU_HEADER_SUFFIX)
  }, title, selectedItemsCount !== undefined ? " (".concat(selectedItemsCount, ")") : ''), actionButton);
};